
/**
 * Configuração do Viewports
 */
export default [
    {
        rule: '0px',
        label: 'mobile'
    },
    {
        rule: '320px',
        label: 'mobile'
    },
    {
        rule: '768px',
        label: 'tablet'
    },
    {
        rule: '1024px',
        label: 'desktop'
    }
]
